import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';
import type { AssistantInfo } from 'shared/src/api/searchService/types';

type Props = {
  assistantInfo: AssistantInfo;
  onPressOriginal: (keyword: string) => void;
  onPressSuggested: (keyword: string) => void;
};

/**
 * 오타 교정 / 키워드 제안 UI
 * - TYPO: "{corrected}(으)로 검색한 결과입니다. {original}(으)로 검색할까요?"
 * - SUGGEST: "{suggestion}을(를) 찾으시나요?"
 */
export const SearchAssistantView: React.FC<Props> = ({
  assistantInfo,
  onPressOriginal,
  onPressSuggested,
}) => {
  const { correct_type, original_query, corrected_query } = assistantInfo;

  // CONVERSION: 오타 교정
  if (correct_type === 'CONVERSION') {
    return (
      <Flex
        height={36}
        padding={{ horizontal: 16, vertical: 5 }}
        backgroundColor="bg_primary"
        justifyContent="center"
      >
        <Flex.Row flexWrap="wrap" alignItems="center">
          <Typography type="subtitle3" color="content_secondary">
            {corrected_query}
          </Typography>
          <Typography type="body3" color="content_secondary">
            (으)로 검색한 결과입니다.{' '}
          </Typography>
          <Flex onPress={() => onPressOriginal(original_query)}>
            <Typography type="subtitle3" color="content_positive">
              {original_query}
            </Typography>
          </Flex>
          <Typography type="body3" color="content_secondary">
            (으)로 검색할까요?
          </Typography>
        </Flex.Row>
      </Flex>
    );
  }

  // SUGGESTION: 키워드 제안
  if (correct_type === 'SUGGESTION') {
    return (
      <Flex
        height={36}
        padding={{ horizontal: 16, vertical: 5 }}
        backgroundColor="bg_primary"
        justifyContent="center"
      >
        <Flex.Row flexWrap="wrap" alignItems="center">
          <Flex onPress={() => onPressSuggested(corrected_query)}>
            <Typography type="subtitle3" color="content_positive">
              {corrected_query}
            </Typography>
          </Flex>
          <Typography type="body3" color="content_secondary">
            {' '}을(를) 찾으시나요?
          </Typography>
        </Flex.Row>
      </Flex>
    );
  }

  return null;
};